var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FD3400;}\n\t.st1{fill:#2F2317;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#2F2317;stroke-width:16;stroke-linecap:round;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  className: "st0",
  cx: 268.5,
  cy: 269.17,
  rx: 261.5,
  ry: 259.83
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  className: "st1",
  cx: 386.6,
  cy: 188.74,
  rx: 38.22,
  ry: 37.97
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st2",
  cx: 401.61,
  cy: 176.54,
  rx: 9.55,
  ry: 9.49
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  className: "st1",
  cx: 150.21,
  cy: 188.2,
  rx: 38.22,
  ry: 37.97
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st2",
  cx: 165.23,
  cy: 176,
  rx: 9.55,
  ry: 9.49
})), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M209.45,258.78"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M371.18,322.24c0,0-84.2-167.32-189.44,0"
}));

function SvgMood1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 540 540",
    style: {
      enableBackground: "new 0 0 540 540"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood1);
export default __webpack_public_path__ + "static/media/mood1.b9ef609515ab42a2a06a98b8249b10d3.svg";
export { ForwardRef as ReactComponent };